import React, { useEffect, useMemo } from "react";

const ChatOverlayFrame = ({
  children,
  isOpen,
  onClose,
  desktopTop = 24,
  desktopWidth = "min(1440px, calc(100vw - 48px))",
  desktopHeight = "calc(100vh - 48px)",
  mobileTop = 12,
  mobileInset = 12,
  mobileBottom = 12,
}) => {
  const useMobileLayout =
    typeof window !== "undefined" && window.innerWidth <= 767;

  const frameStyle = useMemo(() => {
    if (!isOpen) {
      return {
        width: "100%",
        height: "100%",
        minHeight: 0,
      };
    }

    if (useMobileLayout) {
      return {
        position: "fixed",
        top: `${mobileTop}px`,
        left: `${mobileInset}px`,
        right: `${mobileInset}px`,
        bottom: `${mobileBottom}px`,
        zIndex: 1400,
        minHeight: 0,
      };
    }

    return {
      position: "fixed",
      top: `${desktopTop}px`,
      left: "50%",
      transform: "translateX(-50%)",
      width: desktopWidth,
      maxWidth: "calc(100vw - 24px)",
      height: desktopHeight,
      maxHeight: "calc(100vh - 24px)",
      zIndex: 1400,
      minHeight: 0,
    };
  }, [
    desktopHeight,
    desktopTop,
    desktopWidth,
    isOpen,
    mobileBottom,
    mobileInset,
    mobileTop,
    useMobileLayout,
  ]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <>
      {isOpen && (
        <div
          className="ea-chat-overlay-backdrop"
          aria-hidden="true"
          onClick={onClose}
        />
      )}
      <div
        className={`ea-chat-overlay-frame ${isOpen ? "is-open" : ""}`}
        style={frameStyle}
      >
        {children}
      </div>
    </>
  );
};

export default ChatOverlayFrame;
